<template>
    <section class="feature_product_area section_gap_bottom_custom" id="productListHomePage">
    <div class="container">
      <div class="row">
           <Product v-for="item in list.slice(0, 3)" :key="item.id" :product="item"/>
      </div>
      <HowToUseText/>
    </div>

  </section>
</template>
<script>
import HowToUseText from '@/components/HowToUseText'
import Product from '@/components/Product'
import list from '../config/products.json'

export default {
  data () {
    return {
      list
    }
  },
  components: {
    HowToUseText,
    Product
  },
  mounted () {
    this.trackViewFromScroll()
  },
  methods: {
    trackViewFromScroll () {
      let section = document.querySelector('#productListHomePage')
      document.addEventListener('scroll', () => {
        if (window.scrollY >= section.getBoundingClientRect().top) {
          // window.analytics.track('Scroll to Product List Home Page')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductList.vue